import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, of, switchMap, tap, withLatestFrom } from 'rxjs';
import { ReferenceService } from '../../generated/auth/services/reference.service';
import {
  loadListFailure,
  loadListSuccess,
  loadRelationshipTeamList,
  toggleLoadingStatus,
} from './relationship-team.actions';
import { selectRelationshipTeamList, selectRelationshipTeamLoading } from './relationship-team.selectors';

@Injectable()
export class UIEffect {
  private readonly action = inject(Actions);
  private readonly store = inject(Store);
  private readonly service = inject(ReferenceService);

  constructor() {}

  loadList = createEffect(() =>
    this.action.pipe(
      ofType(loadRelationshipTeamList),
      withLatestFrom(this.store.select(selectRelationshipTeamList), this.store.select(selectRelationshipTeamLoading)),
      filter(([action, state, status]) => !state?.length && !status),
      tap(() => this.store.dispatch(toggleLoadingStatus({ status: true }))),
      switchMap((action) =>
        this.service.referenceLookupGetRelationshipTeamGet().pipe(
          switchMap((response) => of(loadListSuccess({ payload: response.result }))),
          catchError((error) => of(loadListFailure({ error }))),
        ),
      ),
    ),
  );
}
